var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "labelStyle" },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Cnuc:",
                  content:
                    _vm.dadosJson.cadastroUc.informacoesAdministrativasUc
                      .cncu || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Nome da UC:",
                  content:
                    _vm.dadosJson.cadastroUc.informacoesAdministrativasUc
                      .nomeUc || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Esfera Administrativa:",
                  content:
                    _vm.dadosJson.cadastroUc.informacoesAdministrativasUc
                      .esferaAdministrativa || "-"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Objetivo de Criação:",
                  content:
                    _vm.dadosJson.cadastroUc.informacoesAdministrativasUc
                      .objetivoCriacaoUc || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Órgão Gestor:",
                  content:
                    _vm.dadosJson.cadastroUc.informacoesAdministrativasUc
                      .orgaoGestor || "-"
                }
              }),
              _c("app-display", {
                attrs: {
                  label: "Categoria de Manejo:",
                  content:
                    _vm.dadosJson.cadastroUc.informacoesAdministrativasUc
                      .categoriaManejo || "-"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ced3859", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ced3859","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/InformacoesGeraisRf.vue
// module id = null
// module chunks = 